import React, {Component} from 'react';
import { Row, Col } from 'antd';
import {getInfoFromLocalStorage, postPublic, setInfoToLocalStorage} from "../actions";
import {LOGO_HEIGHT} from "../constants";
import {getConfigByKey} from "../actions/configList";
import {connect} from "react-redux";
import {applicationName} from "../utils";
import BaseComponent from "../base/BaseComponent";

class LogoArea extends BaseComponent {

    constructor(props){
        super(props);
        this.state ={
            logoImg:"images/logo.png",
            projectTitle_cn:'',
            projectTitle_en:'',

        };
    }

    componentWillMount(){
        let that =this;
        try{
            //首先从sessionStorage中获取。
            var logoImg=getInfoFromLocalStorage("logoImg");
            if(logoImg){
                that.setState({
                    logoImg:logoImg
                })
            }else{
                getConfigByKey({key:"sys.logo"},function (configValue) {
                    if(configValue && configValue.length > 0){
                        setInfoToLocalStorage("logoImg",configValue);
                        that.setState({
                            logoImg:configValue
                        })
                    }
                });
            }

            //获取标题中文名称，
            if(this.props.sysConfig){
                var projectTitleConfig=this.props.sysConfig.getConfigByKey("contribute.project.title");
                if(projectTitleConfig&&projectTitleConfig.configValue){
                    let projectTitle_cn=projectTitleConfig.configValue;
                    this.setState({
                        projectTitle_cn:projectTitle_cn,
                    })
                }

            }
            //获取英文名称，
            if(this.props.sysConfig){
                var projectTitleConfig=this.props.sysConfig.getConfigByKey("contribute.project.title_en");
                if(projectTitleConfig&&projectTitleConfig.configValue){
                    let projectTitle_en=projectTitleConfig.configValue;
                    this.setState({
                        projectTitle_en:projectTitle_en,
                    })
                }

            }
        }catch (e) {
            console.log(e);
        }
    }
    /**
     * 刷新用户菜单缓存
     */
    reloadUserMenu() {
        let url = `/cm-sites-sys/menu/findUserMenuTree?clientType=0`;
        let body ={reload: true};
        let callBack = (data)=>{
            if(data){
                window.location.reload();
            }
        };
        this.request({url, body, callBack});
    }

    render() {
        return (
            <div style={{margin:"60px 0 38px 0"}}>
                <Row>
                    <Col span={24}>
                        <img alt={"系统图标"} style={{margin:"auto",display:"block", width:"61px", height: LOGO_HEIGHT + "px"}} onClick={()=>this.reloadUserMenu()}   src={this.state.logoImg} />
                        {
                            this.props.navigateStatus?<p style={{margin:"10px 0",color:"#FFF",textAlign:"center", fontSize:"18px"}}>{this.state.projectTitle_cn?this.state.projectTitle_cn:process.env.REACT_APP_CNAME}</p>:""
                        }
                        {
                            this.props.navigateStatus?<p style={{color:"#5388c0",textAlign:"center", fontSize:"12px"}}>{this.state.projectTitle_en?this.state.projectTitle_en:'CMSITES MANAGEMENT PLATFORM'}</p>:""
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        navigateStatus:state.systemReducer.navigateStatus,
        currentUser: state.systemReducer.currentUser,
        messageCount:state.systemReducer.messageCount,
        sysConfig : state.systemReducer.config,
    }
}

export default  connect(mapStateToProps)(LogoArea);